import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import {Flex, WhiteSpace} from 'antd-mobile';
import {Link} from "react-router-dom";
import DefaultLayout from "../../components/DefaultLayout";

class ContractDetail extends Component {
    constructor(props){
        super(props);

        const urlParams = new URLSearchParams(window.location.search);
        const object_id = urlParams.get('id');

        this.state = {
            hasError: false,
            height: '100%',
            object_id: object_id,
            userCar: null,
            order: null,
            brandLogo:'no-image',
        };
    }

    componentDidMount() {
        this.setState({height: window.innerHeight + 'px'});
    }

    render() {
        return (<div className='App-block bgWhite' style={{minHeight: this.state.height}}>
            <DefaultLayout {...this.props} title="Thông tin hợp đồng" classNameContent="bgWhite" page_type={1} hiddenFt={true} showBottomPanel={true}>
                <div className="wrap-content">
                    <WhiteSpace size='xl' />
                    <Flex>
                        <Flex.Item>
                            <div style={{ padding: '12.5px', textAlign:'center' }}>
                                <div style={{ color: '#000', fontSize: '14px', marginTop: '7px', borderTop: '1px solid #ddd', padding: '12px 0', borderBottom: '1px solid #ddd' }}>
                                    <span>Màn hình thể hiện thông tin chi tiết hợp đồng</span>
                                    <br/>
                                    <Link to={'/'}> Click để xem/tải Hợp đồng </Link>
                                </div>
                            </div>
                        </Flex.Item>
                    </Flex>
                </div>
            </DefaultLayout>
        </div>);
    }
}

export default (withTranslation())(ContractDetail);